import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output,
  ViewChild,
} from '@angular/core';

@Component({
  selector: 'fz-shared-ui-video-player',
  templateUrl: './shared-ui-video-player.component.html',
  styleUrls: ['./shared-ui-video-player.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SharedUiVideoPlayerComponent implements AfterViewInit {
  @Input()
  videoPoster: string | null = null;
  @Input()
  videoUrl: string | null = null;
  @Output()
  playVideo: EventEmitter<boolean> = new EventEmitter();
  @Output()
  videoPaused: EventEmitter<boolean> = new EventEmitter();
  @Output()
  videoEnded: EventEmitter<boolean> = new EventEmitter();

  @ViewChild('video') video: ElementRef;
  hidePoster = false;

  onPlayVideo() {
    this.hidePoster = true;
    this.video.nativeElement.play();
    this.playVideo.emit(true);
  }

  stopVideo() {
    this.videoPaused.emit(true);
  }
  ngAfterViewInit(): void {
    this.video.nativeElement.addEventListener(
      'ended',
      this.onVideoEnded.bind(this),
    );
    this.video.nativeElement.addEventListener(
      'pause',
      this.stopVideo.bind(this),
    );
  }

  onVideoEnded() {
    this.videoEnded.emit(true);
  }
}
